import * as api from "@/api/stationAutoDj.api";

export const getAutoDj = async ({ commit }, stationKey) => {
  try {
    commit("setLoadingAutoDj", true);

    let autoDj = await api.getAutoDj(stationKey);

    commit("setAutoDj", autoDj);

    commit("setLoadingAutoDj", false);

    return autoDj;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateAutoDj = async ({ commit }, data) => {
  try {
    let autoDj = await api.updateAutoDj(data);

    commit("setAutoDj", autoDj);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getCurrentPlaying = async ({ commit }, stationKey) => {
  try {
    let current = await api.getCurrentPlaying(stationKey);

    commit("setCurrent", current);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const restartPlaylist = async (vuex, stationKey) => {
  try {
    await api.restartPlaylist(stationKey);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const resetAutoDj = async ({ commit }) => {
  try {
    commit("reset");
  } catch (e) {
    console.log(e);
    throw e;
  }
};
